export default [
  {
    path: '/specialist/calendar',
    name: 'apps-calendar',
    component: () => import('@/views/apps/specialist/calendar/Calendar.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },

  {
    path: '/specialist/places',
    name: 'places',
    component: () => import('@/views/apps/specialist/locaisAtendimento/viewLocalAtendimento.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/specialist/chat-settings',
    name: 'chat-Settings',
    component: () => import('@/views/apps/specialist/chat/chatSettings.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },

  {
    path: '/specialist/consultas',
    name: 'queries',
    component: () => import('@/views/apps/specialist/queries/queriesView.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },

  {
    path: '/specialist/balances',
    name: 'balances-specialist',
    component: () => import('@/views/apps/specialist/movimentacoes/viewMovimentacoesSpecialist.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },

  {
    path: '/specialist/payments-transfers',
    name: 'payments_transfers',
    component: () => import('@/views/apps/specialist/payments_transfers/viewTransactions.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },

  {
    path: '/specialist/create',
    name: 'create-specialist',
    component: () => import('@/views/apps/specialist/userSpecialists/creaeSpecialist.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },

  {
    path: '/specialist/perfil',
    name: 'specialist-perfil',
    component: () => import('@/components/perfil/AccountSetting.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },

  {
    path: '/specialist/prontuario/:id',
    name: 'prontuario',
    component: () => import('@/views/apps/specialist/prontuario/Prontuario.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },

  {
    path: '/specialist/records/list',
    name: 'record-list',
    component: () => import('@/views/apps/specialist/records/recordsList.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/specialist/record/view/:id',
    name: 'record-update',
    component: () => import('@/views/apps/specialist/records/update/updateRecord.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/specialist/plantao',
    name: 'plantao-specialist',
    component: () => import('@/views/apps/specialist/plantao/agendarPlantao.vue'),
    meta: {
      // pageTitle: 'Fila de Atendimento',
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/specialist/prontuario-medico/:schedule_id/:record_id',
    name: 'record-create',
    component: () => import('@/views/apps/specialist/records/create/createRecord.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/specialist/prontuario-emma',
    name: 'prontuario-emma',
    component: () => import('@/views/apps/specialist/prontuario/Prontuario.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/specialist/agora.io',
    name: 'agora.io',
    component: () => import('@/components/videoCall/specialist.videoCall.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/specialist/agora-teste',
    name: 'agorateste.io',
    component: () => import('@/views/apps/specialist/teste-agora.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/specialist/app/chat',
    name: 'app-chat',
    component: () => import('@/views/apps/specialist/components/chat/Chat.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },

  {
    path: '/specialist/app/queue-view',
    name: 'app-queue-view',
    component: () => import('@/views/apps/specialist/queue/queueView.vue'),
    meta: {
      layout: 'full',
      // pageTitle: 'Fila de Atendimento',
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/specialist/accout-progress',
    name: 'account-progress',
    component: () => import('@/views/AccountProgressFull.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/specialist/companies',
    name: 'specialist-companies',
    component: () => import('@/views/apps/specialist/companies/Companies.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/specialist/companies/general-information/:id',
    name: 'specialist-companies-general-information',
    component: () => import('@/views/apps/specialist/companies/components/GeneralInformation.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/finance/withdraw',
    name: 'finance-withdraw',
    component: () => import('@/views/apps/specialist/financas/Withdraw.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
  {
    path: '/finance/approve-withdrawal',
    name: 'approve-withdrawal',
    component: () => import('@/views/apps/specialist/financas/ApproveWithdrawal.vue'),
    meta: {
      resource: 'specialist',
      action: 'manage',
    },
  },
]
